import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { JSONRpc } from './service-jsonrpc';
import { Observable, of, observable, Subject, BehaviorSubject, ReplaySubject } from 'rxjs';
import { MinimizeTab } from '../Interfaces/MinimizeTab'


import { environment } from '../../environments/environment';
import { PageRoute } from '../Interfaces/PageRoute'

import * as _ from 'lodash';
@Injectable({
  providedIn: 'root'
})
export class StateService {

    demande:any = new BehaviorSubject("");
    demandeType:any = new BehaviorSubject("");
    dossier:any = new BehaviorSubject("");
    dossierWebamat:any = new BehaviorSubject("");
    quickmenu:any = new BehaviorSubject("");
    etats:any = new BehaviorSubject("");
    filters:any = new BehaviorSubject("");
    editForm:any = new BehaviorSubject("");
    pages:any = new BehaviorSubject("");
    notifications:any = new BehaviorSubject("");
    refresh:any = new BehaviorSubject("");
    droitsApp:any = new BehaviorSubject("");
    contactTypes:any = new BehaviorSubject("");
    zoneTypes:any = new BehaviorSubject("");
    user:any = new BehaviorSubject("");
    subHeader:any = new BehaviorSubject("");
	subHeader2:any = new BehaviorSubject("");

    online:any = new BehaviorSubject(true);
    components: any = new BehaviorSubject([]);
    application:any = new BehaviorSubject("");
    instrucSelected:any = null;
    loadCreated:boolean = false;
    miniminzeTabs: BehaviorSubject<MinimizeTab[]> = new BehaviorSubject([]);
 	messages:any = new BehaviorSubject("");

    public _notifications:any = this.notifications.asObservable();
	
	route: BehaviorSubject<PageRoute> = new BehaviorSubject(new PageRoute());
	searchOptions:any = new BehaviorSubject({});

	menu:BehaviorSubject<any> = new BehaviorSubject({});
	communication:BehaviorSubject<any> = new BehaviorSubject({});	
	
	icon: any = new BehaviorSubject("la la-user");
	menu_item:BehaviorSubject<any> = new BehaviorSubject({});
	menu_items:BehaviorSubject<any> = new BehaviorSubject({});
	type_tiers:BehaviorSubject<any> = new BehaviorSubject({});
	
    constructor(
        private http: HttpClient
        
    ) {}

    updateDemande(demande:any) {
        this.demande.next(demande);
    }
    updateDroitsApp(droits:any){
        this.droitsApp.next(droits);
    }
    updateDemandeType(demandeTypes:any){
        this.demandeType.next(demandeTypes);
    }
    updateDossier(dossier:any) {
        this.dossier.next(dossier);
    }
    updateDossierWebamat(dossier:any) {
        this.dossierWebamat.next(dossier);
    }
    updateStateQuickmenu(state:any) {
        this.quickmenu.next(state);
    }

    updateEtatsDemande(etats:any) {
        this.etats.next(etats);
    }

    updateFilters(filters:any) {
        this.filters.next(filters);
    }
    
    updateEditForm(edit:any) {
        this.editForm.next(edit);
    }
    updateRefresh(refresh: any) {
        this.refresh.next(refresh);
    }
    updateNotifications(notifications:any) {
        let notifGroupByAlerts = _.groupBy(notifications, o => o.etat === 1 && (o.notificationType === "ALERT" || o.notificationType === "LATE"));
        let notifGroupByNotifications = _.groupBy(notifications, o => o.etat === 1 && o.notificationType !== "ALERT" && o.notificationType !== "LATE");
        let notifGroupByAfaire = _.groupBy(notifications, o => o.etat === 2);
        let notifreturn = {
            alerts : notifGroupByAlerts.true ? notifGroupByAlerts.true : [],
            notifications : notifGroupByNotifications.true ? notifGroupByNotifications.true : [],
            afaire : notifGroupByAfaire.true ? notifGroupByAfaire.true : []
        }
        this.notifications.next(notifreturn);
    }

    updatePages(pages:any) {
        this.pages.next(pages);
    }

    updateContactTypes(contacts:any){
        this.contactTypes.next(contacts);
    }
    
    updateZoneTypes(zone:any){
        this.zoneTypes.next(zone);
    }
    
    updateUser(user:any){
        this.user.next(user);
    }

    updateComponents(components: any){
        this.components.next(components);
    }

    updateOnline(online: boolean){
        if(online)
            environment.webservice = "http://assmat.local/webservice/";
        else
            environment.webservice = "offline/";
        this.online.next(online);
    }
    updateSubHeader(header: string){
        this.subHeader.next(header);
    }
	
	updateSubHeader2(header: string){
	       this.subHeader2.next(header);
	}
	
    selectNewCreatedInstruction(instruc: any) {
        this.instrucSelected = instruc;
        this.loadCreated = true;        
    }
    
    updateApplication(app: any){
        this.application.next(app);
     
    }

    removeMinimizeTab(tab: MinimizeTab) {
        let tabs = this.miniminzeTabs.getValue()
        if (tabs.indexOf(tab) !== -1) {
            tabs.splice(tabs.indexOf(tab), 1)
        }
        this.miniminzeTabs.next(tabs)
    }

    addMinimizeTab(tab: MinimizeTab) {
        let tabs = this.miniminzeTabs.getValue()
        tabs.push(tab)
        this.miniminzeTabs.next(tabs)
    }
    
    updateMessages(messages:any) {
        this.messages.next(messages);
    }
	setRoute(route:PageRoute) {
		var r=this.route.getValue();
		console.log('StateService Page route0',r,route)
		if ( r.route!=route.route)
			route.pred=r;
		console.log('StateService Page route1',r,route)
		this.route.next(route);
	}

	getCurrentRoute() {
		return  this.route.getValue();
	}

   setSearchOptions(searchOpts:any,searchType:string){
       var currentSearchOptions = this.searchOptions.getValue();
       currentSearchOptions[searchType] = searchOpts;
       this.searchOptions.next(currentSearchOptions);
   }

   getSearchOptions(searchType:string){
       var currentSearchOptions = this.searchOptions.getValue();
       return currentSearchOptions[searchType] != undefined? currentSearchOptions[searchType]: null;
   }
   
	updateMenu(menu: any) {
		 	 	  this.menu.next(menu);
		 	 }
		 	 	 
 	 getMenu() {
 	 	 return  this.menu.getValue();
 	 }
	 
	 updateIcon(icon: any) {
	   	 	  this.icon.next(icon);
	   	 }
	   	 	 
	  getIcon() {
	  	 return  this.icon.getValue();
	  }
	  
	  updateMenuItem(item: any) {
	  	   	 	  this.menu_item.next(item);
	}
	  	   	 	 
  	  getMenuItems() {
  	  	 return  this.menu_items.getValue();
  	  }
	  
	  updateMenuItems(item: any) {
	    	   	 	  this.menu_items.next(item);
	  }
	    	   	 	 
	  	  getMenuItem() {
	  	  	 return  this.menu_item.getValue();
	  	  }
	  
	 updateTypeTiers(atypeTiers: any) {
		let att:any={}
		if (atypeTiers.length>0) 
			for(var i=0;i<atypeTiers.length;i++) {
		       let tt=atypeTiers[i];
			   if (tt["code"]!=undefined)
				att[tt["code"]]=tt;
			}
				
			
		
	 	 this.type_tiers.next(att);
	 }
	 		 	 	 
	  getTypeTiers() {
	  	 	 return  this.menu.getValue();
	 }

	 
	 
 	updateCommunication(comm: any) {
 		 	 	  this.communication.next(comm);
 		 	 }
 		 	 	 
  	 getCommunication() {
  	 	 return  this.communication.getValue();
  	 }
	 
	 
}